import { Member } from "../../@types/member.types";
import { MEMBER_ATTRIBUTES } from "../../constants/caption/memberAttributes";
import ROLES from "../../constants/roles";
import { dateConverterToUSFormat, dateTimeZoneConverter } from "./date";
import { dollarize, numberToDollarStr } from "./dollar";
import initCapitalize from "./initCapitalize";

export const handleDateCellRenderer = ({ value }: { value: string | null | false | undefined }): JSX.Element => {
	if (value === false || value === undefined || value === "CURRENT" || value === "FUTURE") {
		return <></>;
	}
	if (value?.length === 0) {
		return <>N/A</>;
	}
	return <div>{value ? (dateTimeZoneConverter(value) as string) : "N/A"}</div>;
};

export const handlePlanEndDateCellRenderer = ({ value }: { value: string }): JSX.Element => {
	// return <div>{value ? (dateTimeZoneConverter(value) as string) : "CURRENT"}</div>;
	return <div>{value ? (dateTimeZoneConverter(value) as string) : "N/A"}</div>;
};

export const handleDollarCellRenderer = ({ value }: { value: number }): JSX.Element => {
	// if (value === false || value === undefined) {
	// 	return <></>;
	// }

	return <div>{dollarize(value)}</div>;
};

export const handleMemberAttributeCellRenderer = ({ value }: { value: string }): JSX.Element => {
	return <div>{MEMBER_ATTRIBUTES[value as keyof typeof MEMBER_ATTRIBUTES]}</div>;
};

export const handleCapitalizeCellRenderer = ({ value }: { value: string }) => {
	const capitalize = value ? initCapitalize(value) : null;
	return <div>{capitalize}</div>;
};

export const handleNameCellRenderer = ({ value }: { value: any }) => {
	let name;
	if (value.middle_name) name = value.first_name + " " + value.middle_name + " " + value.last_name;
	else name = value.first_name + " " + value.last_name;
	return <div>{value ? name : "N/A"}</div>;
};

export const handleMemberIdCellRenderer = ({ value, data }: { value: string; data: Member }) => {
	return data.role === ROLES.employee ? value : "N/A";
};

export const handleValueCellRenderer = ({ value }: { value: string }) => {
	return <div>{value ? value : "N/A"}</div>;
};

export const handleLastUpdateDateCellRenderer = ({ value }: { value: string }) =>
	dateConverterToUSFormat(value) as string;

export const handleCreateDateCellRenderer = ({ value }: { value: string }) => dateConverterToUSFormat(value) as string;
